import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from 'i18n';
import { requestInvoicePdfLink } from 'store/api/cuverse-api/invoice-pdf-links/invoice-pdf-links.service';
import { InvoicePdfLinksResponseSchema } from 'store/api/cuverse-api/invoice-pdf-links/types/download-invoice-response';

import { requestWithZodSchema } from 'utils/common/requestWithZodSchema';
import { notifyError } from 'utils/notify/notify.utils';

export const fetchInvoicePdfLinksAction = createAsyncThunk(
  'invoicePdfLinks/fetch',
  async (orderId: number) =>
    await requestWithZodSchema(
      () => requestInvoicePdfLink(orderId),
      InvoicePdfLinksResponseSchema,
    ).catch((error) => {
      notifyError(i18n.t('notifyMessages.invoice.downloadPdfError'));
      throw error;
    }),
);
export const fetchInvoicePdfLinkAction = createAsyncThunk(
  'invoicePdfLink/fetch',
  async (orderId: number) =>
    await requestWithZodSchema(
      () => requestInvoicePdfLink(orderId),
      InvoicePdfLinksResponseSchema,
    ).catch((error) => {
      notifyError(i18n.t('notifyMessages.invoice.downloadPdfError'));
      throw error;
    }),
);
